import { signal } from '@preact/signals'

/**
 * Сервер отвергает посылку — и это длится.
 *
 * С вечера 23.10.2026 телефон сутки получал на каждый обмен ответ 400 и молча повторял его:
 * записи копились только на устройстве, и никто об этом не знал. Отсутствие сети — не сбой,
 * приложение работает и без сервера; а вот отказ сервера принять данные человек должен видеть.
 *
 * Момент первого отказа переживает перезагрузку: после неё обмена может и не быть, пока
 * человек ничего не изменит, а предупреждение должно остаться на экране.
 */
const KEY = 'moonwake.sync_rejected_since'

function читать(): number | null {
  try {
    const raw = globalThis.localStorage?.getItem(KEY)
    const n = raw === null || raw === undefined ? NaN : Number(raw)
    return Number.isFinite(n) ? n : null
  } catch {
    return null
  }
}

/** С какого момента сервер отвергает посылки; null — всё в порядке (или просто нет сети). */
export const syncRejectedSince = signal<number | null>(читать())

/** Сервер ответил отказом (не про вход: 401/403 ведут к выходу из аккаунта отдельно). */
export function noteSyncRejected(status: number, now = Date.now()): void {
  if (status === 401 || status === 403) return
  if (syncRejectedSince.value !== null) return
  syncRejectedSince.value = now
  try {
    globalThis.localStorage?.setItem(KEY, String(now))
  } catch {
    // Хранилища нет — предупреждение проживёт до перезагрузки
  }
}

/** Обмен прошёл: сбоя больше нет. */
export function noteSyncOk(): void {
  if (syncRejectedSince.value === null) return
  syncRejectedSince.value = null
  try {
    globalThis.localStorage?.removeItem(KEY)
  } catch {
    // см. выше
  }
}
